/* - - - - - NPM PACKAGE - - - - - */
require('flexslider');
require('jquery-hoverintent');
require('jquery-lazyload');
require('jquery-mask-plugin');
require('jquery.cookie');
require('jquery.mousewheel');
require('jscrollpane');
//require('owl.carousel2');
/* - - - - - NPM PACKAGE - END- - */

/* - - - - - CUSTOM PACKAGE - - - - - */
require('./vendors/jqueryUI/jquery-ui.min.js');
require('./vendors/jqueryUI/jquery.eajaxspin.js');
require('./vendors/jqueryUI/jquery.easing.1.3.js');
require('./vendors/jqueryUI/jquery.validate.1.13.min.js');
require('./vendors/jqueryUI/jquery.unobtrusive-ajax.min.js');
require('./vendors/fancybox/jquery.fancybox.js');
require('./vendors/fancybox/helpers/jquery.fancybox-thumbs.js');
require('./vendors/fancybox/helpers/jquery.fancybox-media.js');
require('./vendors/upper/upper.js');
require('./vendors/selectbox/selectbox.js');
require('./vendors/bxslider/bxslider.js');
require('./vendors/rnd-validate/rnd-validate.js');
require('./vendors/rnd-menu/js/rnd-mobile-menu.js');
require('./vendors/owl-carousel/owl.carousel.js');
//require('./vendors/jscrollpane/jquery.jscrollpane.js');
//require('./vendors/lazyload/jquery.lazyload.js');
require('./vendors/facebook/facebook.js');
require('./Views/Layout/Layout.js');
/* - - - - - CUSTOM PACKAGE - END - - */


